import { AsyncPipe } from "@angular/common";
import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ConfirmDialogModule } from "primeng-v17/confirmdialog";
import { ConfirmPopupModule } from "primeng-v17/confirmpopup";
import { ChatWidgetDialogComponent } from "../../features/chat/chat-widget-dialog/chat-widget-dialog.component";
import { MessageErrorComponent } from "../../features/message/message-error/message-error.component";
import { NotificationsComponent } from "../../features/notifications/notifications.component";
import { UserFeedbackComponent } from "../../features/user-feedback/user-feedback.component";
import { ConfirmPopupFixDirective } from "../../shared/primeng/confirm-popup-fix/confirm-popup-fix.directive";
import { DialogKeysDirective } from "../../shared/primeng/dialog-keys/dialog-keys.directive";
import { FooterComponent } from "../footer/footer.component";
import { OldUiCountdownBannerComponent } from "../old-ui-countdown-banner/old-ui-countdown-banner.component";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { TopbarComponent } from "../topbar/topbar.component";
import { NewUiMainComponent } from "./new-ui-main.component";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  imports: [
    TopbarComponent,
    OldUiCountdownBannerComponent,
    SidebarComponent,
    RouterOutlet,
    FooterComponent,
    ConfirmPopupModule,
    ConfirmPopupFixDirective,
    DialogKeysDirective,
    ConfirmDialogModule,
    UserFeedbackComponent,
    NotificationsComponent,
    MessageErrorComponent,
    ChatWidgetDialogComponent,
    AsyncPipe,
  ],
})
export class MainComponent extends NewUiMainComponent {}
